module.exports = __webpack_public_path__ + "static/media/480.58218f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-insect/dark/480.png
// module id = 2184
// module chunks = 2